module.exports = __webpack_public_path__ + "ad131f4bd432301eed652def7250cc6f.MP3";